import React from 'react';

import { EbayButton } from '../EbayButton';

export function EbaySignupButton() {
  return <EbayButton />;
}
